
import { Drawer } from "antd";
import { observer } from "mobx-react-lite";
import React, { useContext,createContext } from "react";
import renderHTML from "react-render-html";
import RequestStore from "../approvals/store/requeststore";

const requestStoreCtx=createContext(RequestStore)

export const CommentPane = observer(() => {
       const requestStore =useContext(requestStoreCtx);
    return (
        <Drawer
      title={requestStore.reqObj?.title}
      placement="right"
      width={300}
      closable={true}
      destroyOnClose={true}
      onClose={() => {
        requestStore.showCommentPane = false;
      }}
      visible={requestStore.showCommentPane }
    >
       {requestStore.reqObj &&
        renderHTML(requestStore?.reqObj?.comment)} 
    </Drawer>
    )
});

